import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

export default function ConsultationForm() {
  const { theme } = useTheme();

  return (
    <div id="consultation-form" className={`relative min-h-screen py-8 px-4 ${
      theme === 'dark' ? 'bg-[#0B1019]' : 'bg-white'
    }`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="max-w-[600px] mx-auto mb-16" // Added margin bottom
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600">
            Ready to Transform Your Business?
          </h2>
          <p className={theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}>
            Book a consultation below to discover how our solutions can revolutionize your operations
          </p>
        </div>
        
        <div 
          className={`w-full overflow-hidden ${
            theme === 'dark' ? 'bg-[#0B1019]' : 'bg-white'
          }`}
          style={{ height: '700px' }}
        >
          <iframe
            src={`https://calendly.com/basolutionsofficial/consultation?hide_gdpr_banner=1&background_color=${
              theme === 'dark' ? '0B1019' : 'ffffff'
            }&text_color=${
              theme === 'dark' ? 'ffffff' : '000000'
            }&primary_color=60A5FA`}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule a consultation"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              background: theme === 'dark' ? '#0B1019' : '#ffffff',
              display: 'block'
            }}
          />
        </div>
      </motion.div>
      <div className={`absolute bottom-8 left-0 right-0 text-center ${
        theme === 'dark' ? 'text-gray-500' : 'text-gray-400'
      } text-sm`}>
        © 2025, Business Automation Solutions
      </div>
    </div>
  );
}